import React, { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import Logo from "@components/common/Logo";
import { DEFAULT_DATE_FORMAT } from "@constants";

interface DMSurveyIntroductionProps {
  companyName?: string | null;
  companyLogo?: string | null;
  deadline?: string | null;
  title?: string;
}

export const DMSurveyIntroduction: FC<DMSurveyIntroductionProps> = ({
  companyName,
  companyLogo,
  deadline,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        {companyLogo ? (
          <img
            src={companyLogo}
            alt={companyName || "Company logo"}
            style={{
              maxHeight: "80px",
              maxWidth: "200px",
              objectFit: "contain",
            }}
          />
        ) : (
          <Logo type="green0meter" height={80} />
        )}
      </Box>

      <Stack spacing={1}>
        <Typography variant="h4" component="h1" fontWeight={600}>
          {title ||
            (companyName
              ? t("dmSurvey.title", "ESG Survey {{companyName}}", {
                  companyName,
                })
              : t("dmSurvey.title", "ESG Survey", {}))}
        </Typography>
      </Stack>

      <Typography variant="body1" sx={{ mt: 2, whiteSpace: "pre-line" }}>
        {t(
          "dmSurvey.introduction",
          "Dear Sir or Madam,\n\nYou are invited to participate in a stakeholder dialogue as part of the double materiality assessment in accordance with the CSRD (Corporate Sustainability Reporting Directive). Your task is to assess the significance of selected sustainability topics for {{companyName}}.{{deadlineText}}",
          {
            companyName: companyName || t("dmSurvey.company", "the company"),
            deadlineText: deadline
              ? t(
                  "dmSurvey.deadlineText",
                  " Please complete this questionnaire no later than {{deadline}}.",
                  {
                    deadline: dayjs(deadline).format(DEFAULT_DATE_FORMAT),
                  },
                )
              : "",
          },
        )}
      </Typography>
    </Stack>
  );
};
